export default [
    {
        name: "NASDAQ Stock Exchange",
        acronym: "NASDAQ",
        mic: "XNAS",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.nasdaq.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7557411, lng: -73.9857521 },
        address: "151 W 42nd St, New York, NY 10036, USA",
    },
    {
        name: "New York Stock Exchange",
        acronym: "NYSE",
        mic: "XNYS",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.nyse.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.706877, lng: -74.0112654 },
        address: "11 Wall St, New York, NY 10005, USA",
    },
    {
        name: "NYSE ARCA",
        acronym: "NYSEARCA",
        mic: "ARCX",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.nyse.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.706877, lng: -74.0112654 },
        address: "11 Wall St, New York, NY 10005, USA",
    },
    {
        name: "OTC Markets",
        acronym: "",
        mic: "OTCM",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7146797, lng: -74.0172042 },
        address:
            "300 Vesey Street (One North End Ave), 12th Floor, North End Ave, New York, NY 10282, USA",
    },
    {
        name: "Buenos Aires Stock Exchange",
        acronym: "BCBA",
        mic: "XBUE",
        country: "Argentina",
        country_code: "AR",
        city: "Buenos Aires",
        website: "www.bcba.sba.com.ar",
        timezone: {
            timezone: "America/Argentina/Buenos_Aires",
            abbr: "-03",
            abbr_dst: "-03",
        },
        currency: { code: "ARS", symbol: "AR$", name: "Argentine Peso" },
        coordinates: { lat: -34.603775, lng: -58.370861 },
        address: "Sarmiento 299, C1041 AAE, Buenos Aires, Argentina",
    },
    {
        name: "Bahrein Bourse",
        acronym: "BSE",
        mic: "XBAH",
        country: "Bahrain",
        country_code: "BH",
        city: "Manama",
        website: "www.bahrainbourse.com.bh",
        timezone: { timezone: "Asia/Bahrain", abbr: "+03", abbr_dst: "+03" },
        currency: { code: "BHD", symbol: "BD", name: "Bahraini Dinar" },
        coordinates: { lat: 26.2374887, lng: 50.5732606 },
        address:
            "4th Floor, BFH Mall, Bahrain Financial Harbor, Manama, المنامة، Bahrain",
    },
    {
        name: "Euronext Brussels",
        acronym: "Euronext",
        mic: "XBRU",
        country: "Belgium",
        country_code: "BE",
        city: "Brussels",
        website: "www.euronext.com",
        timezone: {
            timezone: "Europe/Brussels",
            abbr: "CET",
            abbr_dst: "CEST",
        },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 50.8479745, lng: 4.3503697 },
        address: "Pl. de la Bourse, 1000 Bruxelles, Belgium",
    },
    {
        name: "B3 - Brasil Bolsa Balcão S.A",
        acronym: "Bovespa",
        mic: "BVMF",
        country: "Brazil",
        country_code: "BR",
        city: "Sao Paulo",
        website: "www.bmfbovespa.com.br",
        timezone: {
            timezone: "America/Sao_Paulo",
            abbr: "-03",
            abbr_dst: "-03",
        },
        currency: { code: "BRL", symbol: "R$", name: "Brazilian Real" },
        coordinates: { lat: -23.5464344, lng: -46.6347618 },
        address:
            "Praça Antônio Prado, 48 - Centro Histórico de São Paulo, São Paulo - SP, 01010-901, Brazil",
    },
    {
        name: "Toronto Stock Exchange",
        acronym: "TSX",
        mic: "XTSE",
        country: "Canada",
        country_code: "CA",
        city: "Toronto",
        website: "www.tse.com",
        timezone: { timezone: "America/Toronto", abbr: "EST", abbr_dst: "EDT" },
        currency: { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
        coordinates: { lat: 43.6482752, lng: -79.3829204 },
        address: "130 King St W, Toronto, ON M5X 1J2, Canada",
    },
    {
        name: "Canadian Securities Exchange",
        acronym: "CNSX",
        mic: "XCNQ",
        country: "Canada",
        country_code: "CA",
        city: "Toronto",
        website: "www.cnsx.ca",
        timezone: { timezone: "America/Toronto", abbr: "EST", abbr_dst: "EDT" },
        currency: { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
        coordinates: { lat: 43.6486362, lng: -79.38174389999999 },
        address: "100 King St W Suite 7210, Toronto, ON M5X 1E1, Canada",
    },
    {
        name: "Santiago Stock Exchange",
        acronym: "BVS",
        mic: "XSGO",
        country: "Chile",
        country_code: "CL",
        city: "Santiago",
        website: "www.bolsadesantiago.com",
        timezone: {
            timezone: "America/Santiago",
            abbr: "-03",
            abbr_dst: "-04",
        },
        currency: { code: "CLP", symbol: "CL$", name: "Chilean Peso" },
        coordinates: { lat: -33.4423647, lng: -70.6517666 },
        address: "La Bolsa 64, Santiago, Región Metropolitana, Chile",
    },
    {
        name: "Shanghai Stock Exchange",
        acronym: "SSE",
        mic: "XSHG",
        country: "China",
        country_code: "CN",
        city: "Shanghai",
        website: "www.sse.com.cn",
        timezone: { timezone: "Asia/Shanghai", abbr: "CST", abbr_dst: "CST" },
        currency: { code: "CNY", symbol: "CN¥", name: "Chinese Yuan" },
        coordinates: { lat: 31.236342, lng: 121.511388 },
        address:
            "China, Shanghai Shi, Pudong Xinqu, Lu Jia Zui, Pudong S Rd, 528号上海证券大厦",
    },
    {
        name: "Shenzhen Stock Exchange",
        acronym: "SZSE",
        mic: "XSHE",
        country: "China",
        country_code: "CN",
        city: "Shenzhen",
        website: "www.szse.cn",
        timezone: { timezone: "Asia/Shanghai", abbr: "CST", abbr_dst: "CST" },
        currency: { code: "CNY", symbol: "CN¥", name: "Chinese Yuan" },
        coordinates: { lat: 22.5476835, lng: 114.084925 },
        address:
            "Waimao Rd, Hua Qiang Bei, Futian Qu, Shenzhen Shi, Guangdong Sheng, China",
    },
    {
        name: "Bolsa de Valores de Colombia",
        acronym: "BVC",
        mic: "XBOG",
        country: "Colombia",
        country_code: "CO",
        city: "Bogota",
        website: "www.bvc.com.co",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "COP", symbol: "CO$", name: "Colombian Peso" },
        coordinates: { lat: 4.6543627, lng: -74.05625959999999 },
        address: "Ak. 7 ###71-21, Bogotá, Colombia",
    },
    {
        name: "Copenhagen Stock Exchange",
        acronym: "OMXC",
        mic: "XCSE",
        country: "Denmark",
        country_code: "DK",
        city: "Copenhagen",
        website: "www.nasdaqomxnordic.com",
        timezone: {
            timezone: "Europe/Copenhagen",
            abbr: "CET",
            abbr_dst: "CEST",
        },
        currency: { code: "DKK", symbol: "Dkr", name: "Danish Krone" },
        coordinates: { lat: 55.67525999999999, lng: 12.5830819 },
        address: "Slotsholmsgade 8, 5700 København, Denmark",
    },
    {
        name: "Eqyptian Exchange",
        acronym: "EGX",
        mic: "XCAI",
        country: "Egypt",
        country_code: "EG",
        city: "Cairo",
        website: "www.egyptse.com",
        timezone: { timezone: "Africa/Cairo", abbr: "EET", abbr_dst: "EET" },
        currency: { code: "EGP", symbol: "EGP", name: "Egyptian Pound" },
        coordinates: { lat: 30.0459662, lng: 31.2365103 },
        address:
            "6 Al Bustan St, Bab Al Louq, Qasr El Nil, Cairo Governorate, Egypt",
    },
    {
        name: "Tallinn Stock Exchange",
        acronym: "OMXT",
        mic: "XTAL",
        country: "Estonia",
        country_code: "EE",
        city: "Tallinn",
        website: "www.nasdaqbaltic.com",
        timezone: { timezone: "Europe/Tallinn", abbr: "EET", abbr_dst: "EEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 59.43696079999999, lng: 24.7535747 },
        address: "Tallinn, Estonia",
    },
    {
        name: "Helsinki Stock Exchange",
        acronym: "OMXH",
        mic: "XHEL",
        country: "Finland",
        country_code: "FI",
        city: "Helsinki",
        website: "www.nasdaqomxnordic.com",
        timezone: {
            timezone: "Europe/Helsinki",
            abbr: "EET",
            abbr_dst: "EEST",
        },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 60.1684125, lng: 24.9492156 },
        address: "Fabianinkatu 14, 00100 Helsinki, Finland",
    },
    {
        name: "Euronext Paris",
        acronym: "Euronext",
        mic: "XPAR",
        country: "France",
        country_code: "FR",
        city: "Paris",
        website: "www.euronext.com",
        timezone: { timezone: "Europe/Paris", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 48.8905381, lng: 2.2466585 },
        address:
            "7 Terrasse des reflets, 14 Passerelle des Reflets, 92400 Courbevoie, France",
    },
    {
        name: "Deutsche Börse",
        acronym: "FSX",
        mic: "XFRA",
        country: "Germany",
        country_code: "DE",
        city: "Frankfurt",
        website: "www.deutsche-boerse.com",
        timezone: { timezone: "Europe/Berlin", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 50.1361645, lng: 8.5696316 },
        address: "Mergenthalerallee 61, 65760 Eschborn, Germany",
    },
    {
        name: "Börse Stuttgart",
        acronym: "XSTU",
        mic: "XSTU",
        country: "Germany",
        country_code: "DE",
        city: "Stuttgart",
        website: "www.boerse-stuttgart.de",
        timezone: { timezone: "Europe/Berlin", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 48.7797654, lng: 9.1749902 },
        address: "Börsenstraße 4, 70174 Stuttgart, Germany",
    },
    {
        name: "Deutsche Börse Xetra",
        acronym: "XETR",
        mic: "XETRA",
        country: "Germany",
        country_code: "DE",
        city: "Frankfurt",
        website: "",
        timezone: { timezone: "Europe/Berlin", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 50.1361645, lng: 8.5696316 },
        address: "Mergenthalerallee 61, 65760 Eschborn, Germany",
    },
    {
        name: "Hong Kong Stock Exchange",
        acronym: "HKEX",
        mic: "XHKG",
        country: "Hong Kong",
        country_code: "HK",
        city: "Hong Kong",
        website: "www.hkex.com.hk",
        timezone: { timezone: "Asia/Hong_Kong", abbr: "HKT", abbr_dst: "HKT" },
        currency: { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
        coordinates: { lat: 22.2852764, lng: 114.2734238 },
        address: "1 Chun Ying St, Tseung Kwan O Industrial Estate, Hong Kong",
    },
    {
        name: "Nasdaq Island",
        acronym: "XICE",
        mic: "XICE",
        country: "Iceland",
        country_code: "IS",
        city: "Reykjavík",
        website: "www.nasdaqomxnordic.com",
        timezone: {
            timezone: "Atlantic/Reykjavik",
            abbr: "GMT",
            abbr_dst: "GMT",
        },
        currency: { code: "ISK", symbol: "Ikr", name: "Icelandic Króna" },
        coordinates: { lat: 64.1396221, lng: -21.8944323 },
        address: "Laugavegur 182, 105 Reykjavík, Iceland",
    },
    {
        name: "Bombay Stock Exchange",
        acronym: "MSE",
        mic: "XBOM",
        country: "India",
        country_code: "IN",
        city: "Mumbai",
        website: "www.bseindia.com",
        timezone: { timezone: "Asia/Kolkata", abbr: "IST", abbr_dst: "IST" },
        currency: { code: "INR", symbol: "Rs", name: "Indian Rupee" },
        coordinates: { lat: 18.9299891, lng: 72.83340799999999 },
        address:
            "Phiroze Jeejeebhoy Towers, Dalal St, Kala Ghoda, Fort, Mumbai, Maharashtra 400001, India",
    },
    {
        name: "National Stock Exchange India",
        acronym: "NSE",
        mic: "XNSE",
        country: "India",
        country_code: "IN",
        city: "Mumbai",
        website: "www.nseindia.com",
        timezone: { timezone: "Asia/Kolkata", abbr: "IST", abbr_dst: "IST" },
        currency: { code: "INR", symbol: "Rs", name: "Indian Rupee" },
        coordinates: { lat: 19.0602766, lng: 72.8598993 },
        address:
            "Exchange Plaza Block G, C 1, Bandra Kurla Complex, G Block BKC, Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra 400051, India",
    },
    {
        name: "Jakarta Stock Exchange",
        acronym: "IDX",
        mic: "XIDX",
        country: "Indonesia",
        country_code: "ID",
        city: "Jakarta",
        website: "www.idx.co.id",
        timezone: { timezone: "Asia/Jakarta", abbr: "WIB", abbr_dst: "WIB" },
        currency: { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
        coordinates: { lat: -6.2231971, lng: 106.8089411 },
        address:
            "Jl. Jend. Sudirman No.Kav. 52 - 53, RT.5/RW.3, Senayan, Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12190, Indonesia",
    },
    {
        name: "Tel Aviv Stock Exchange",
        acronym: "TASE",
        mic: "XTAE",
        country: "Israel",
        country_code: "IL",
        city: "Tel Aviv",
        website: "www.tase.co.il",
        timezone: { timezone: "Asia/Jerusalem", abbr: "IST", abbr_dst: "IDT" },
        currency: { code: "ILS", symbol: "₪", name: "Israeli New Sheqel" },
        coordinates: { lat: 32.0643377, lng: 34.7703709 },
        address: "Ahuzat Bayit St 2, Tel Aviv-Yafo, 6525216, Israel",
    },
    {
        name: "Borsa Italiana",
        acronym: "MIL",
        mic: "XMIL",
        country: "Italy",
        country_code: "IT",
        city: "Milano",
        website: "www.borsaitaliana.it",
        timezone: { timezone: "Europe/Rome", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 45.4651396, lng: 9.1831757 },
        address: "P.za degli Affari, 6, 20123 Milano MI, Italy",
    },
    {
        name: "Nagoya Stock Exchange",
        acronym: "NSE",
        mic: "XNGO",
        country: "Japan",
        country_code: "JP",
        city: "Nagoya",
        website: "www.nse.or.jp",
        timezone: { timezone: "Asia/Tokyo", abbr: "JST", abbr_dst: "JST" },
        currency: { code: "JPY", symbol: "¥", name: "Japanese Yen" },
        coordinates: { lat: 35.166973, lng: 136.905646 },
        address: "3-chōme-8-20 Sakae, Naka Ward, Nagoya, Aichi 460-0008, Japan",
    },
    {
        name: "Fukuoka Stock Exchange",
        acronym: "XFKA",
        mic: "XFKA",
        country: "Japan",
        country_code: "JP",
        city: "Fukuoka",
        website: "www.fse.or.jp",
        timezone: { timezone: "Asia/Tokyo", abbr: "JST", abbr_dst: "JST" },
        currency: { code: "JPY", symbol: "¥", name: "Japanese Yen" },
        coordinates: { lat: 33.59134, lng: 130.397135 },
        address: "2-chōme-14-2 Tenjin, Chuo Ward, Fukuoka, 810-0001, Japan",
    },
    {
        name: "Sapporo Stock Exchange",
        acronym: "XSAP",
        mic: "XSAP",
        country: "Japan",
        country_code: "JP",
        city: "Sapporo",
        website: "www.sse.or.jp",
        timezone: { timezone: "Asia/Tokyo", abbr: "JST", abbr_dst: "JST" },
        currency: { code: "JPY", symbol: "¥", name: "Japanese Yen" },
        coordinates: { lat: 43.0590971, lng: 141.3500164 },
        address:
            "5-chōme-14番地１ Minami 1 Jōnishi, Chuo Ward, Sapporo, Hokkaido 060-0061, Japan",
    },
    {
        name: "Nasdaq Riga",
        acronym: "OMXR",
        mic: "XRIS",
        country: "Latvia",
        country_code: "LV",
        city: "Riga",
        website: "www.nasdaqbaltic.com",
        timezone: { timezone: "Europe/Riga", abbr: "EET", abbr_dst: "EEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 56.9508132, lng: 24.1091109 },
        address: "Vaļņu iela 1, Centra rajons, Rīga, LV-1050, Latvia",
    },
    {
        name: "Nasdaq Vilnius",
        acronym: "OMXV",
        mic: "XLIT",
        country: "Lithuania",
        country_code: "LT",
        city: "Vilnius",
        website: "www.nasdaqbaltic.com",
        timezone: { timezone: "Europe/Vilnius", abbr: "EET", abbr_dst: "EEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 54.699482, lng: 25.2651002 },
        address: "Konstitucijos pr. 29, Vilnius 08501, Lithuania",
    },
    {
        name: "Malaysia Stock Exchange",
        acronym: "MYX",
        mic: "XKLS",
        country: "Malaysia",
        country_code: "MY",
        city: "Kuala Lumpur",
        website: "www.bursamalaysia.com",
        timezone: {
            timezone: "Asia/Kuala_Lumpur",
            abbr: "+08",
            abbr_dst: "+08",
        },
        currency: { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
        coordinates: { lat: 3.1482515, lng: 101.7014032 },
        address:
            "Bursa Malaysia Berhad (30632-P, Exchange Square, Bukit Kewangan, 50200 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur, Malaysia",
    },
    {
        name: "Mexican Stock Exchange",
        acronym: "BMV",
        mic: "XMEX",
        country: "Mexico",
        country_code: "MX",
        city: "Mexico City",
        website: "www.bmv.com.mx",
        timezone: {
            timezone: "America/Mexico_City",
            abbr: "CST",
            abbr_dst: "CDT",
        },
        currency: { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
        coordinates: { lat: 19.4326077, lng: -99.133208 },
        address:
            "Historic center of Mexico City, Centro, Cuauhtémoc, 06060 Mexico City, CDMX, Mexico",
    },
    {
        name: "Euronext Amsterdam",
        acronym: "Euronext",
        mic: "XAMS",
        country: "Netherlands",
        country_code: "NL",
        city: "Amsterdam",
        website: "www.euronext.com",
        timezone: {
            timezone: "Europe/Amsterdam",
            abbr: "CET",
            abbr_dst: "CEST",
        },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 52.3741744, lng: 4.8959187 },
        address: "Beursplein 5, 1012 JW Amsterdam, Netherlands",
    },
    {
        name: "New Zealand Stock Exchange",
        acronym: "NZX",
        mic: "XNZE",
        country: "New Zealand",
        country_code: "NZ",
        city: "Wellington",
        website: "www.nzx.com",
        timezone: {
            timezone: "Pacific/Auckland",
            abbr: "NZDT",
            abbr_dst: "NZST",
        },
        currency: { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
        coordinates: { lat: -41.2898246, lng: 174.7795348 },
        address:
            "11 Cable Street, Wellington Central, Wellington 6011, New Zealand",
    },
    {
        name: "Nigerian Stock Exchange",
        acronym: "NSE",
        mic: "XNSA",
        country: "Nigeria",
        country_code: "NG",
        city: "Lagos",
        website: "www.nse.com.ng",
        timezone: { timezone: "Africa/Lagos", abbr: "WAT", abbr_dst: "WAT" },
        currency: { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
        coordinates: { lat: 6.452719999999999, lng: 3.3879998 },
        address: "4 Custom St, Marina 102273, Lagos, Nigeria",
    },
    {
        name: "Oslo Stock Exchange",
        acronym: "OSE",
        mic: "XOSL",
        country: "Norway",
        country_code: "NO",
        city: "Oslo",
        website: "www.oslobors.no",
        timezone: { timezone: "Europe/Oslo", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "NOK", symbol: "Nkr", name: "Norwegian Krone" },
        coordinates: { lat: 59.9088278, lng: 10.7477679 },
        address: "Tollbugata 2, 0152 Oslo, Norway",
    },
    {
        name: "Bolsa de Valores de Lima",
        acronym: "BVL",
        mic: "XLIM",
        country: "Peru",
        country_code: "PE",
        city: "Lima",
        website: "www.bvl.com.pe",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "PEN", symbol: "S/.", name: "Peruvian Nuevo Sol" },
        coordinates: { lat: -12.0486718, lng: -77.0314915 },
        address: "Jirón Carabaya 490, Cercado de Lima 15001, Peru",
    },
    {
        name: "Warsaw Stock Exchange",
        acronym: "GPW",
        mic: "XWAR",
        country: "Poland",
        country_code: "PL",
        city: "Warsaw",
        website: "www.gpw.pl",
        timezone: { timezone: "Europe/Warsaw", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 52.2299561, lng: 21.0234149 },
        address: "Książęca 4, 00-498 Warszawa, Poland",
    },
    {
        name: "Euronext Lisbon",
        acronym: "Euronext",
        mic: "XLIS",
        country: "Portugal",
        country_code: "PT",
        city: "Lisboa",
        website: "www.euronext.com",
        timezone: { timezone: "Europe/Lisbon", abbr: "WET", abbr_dst: "WEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 38.7210105, lng: -9.1456241 },
        address: "Av. da Liberdade 196, 1250-096 Lisboa, Portugal",
    },
    {
        name: "Qatar Stock Exchange",
        acronym: "QE",
        mic: "DSMD",
        country: "Qatar",
        country_code: "QA",
        city: "Doha",
        website: "www.qatarexchange.qa",
        timezone: { timezone: "Asia/Qatar", abbr: "+03", abbr_dst: "+03" },
        currency: { code: "QAR", symbol: "QR", name: "Qatari Rial" },
        coordinates: { lat: 25.3268528, lng: 51.5320989 },
        address: "Al Dana Tower, Doha, Qatar",
    },
    {
        name: "Moscow Stock Exchange",
        acronym: "MOEX",
        mic: "MISX",
        country: "Russia",
        country_code: "RU",
        city: "Moscow",
        website: "www.moex.com",
        timezone: { timezone: "Europe/Moscow", abbr: "MSK", abbr_dst: "MSK" },
        currency: { code: "RUB", symbol: "RUB", name: "Russian Ruble" },
        coordinates: { lat: 55.752888, lng: 37.6093958 },
        address: "Vozdvizhenka St., 4/7, стр. 1, Moskva, Russia, 125009",
    },
    {
        name: "Saudi Stock Exchange",
        acronym: "TADAWUL",
        mic: "XSAU",
        country: "Saudi Arabia",
        country_code: "SA",
        city: "Riyadh",
        website: "www.tadawul.com.sa",
        timezone: { timezone: "Asia/Riyadh", abbr: "+03", abbr_dst: "+03" },
        currency: { code: "SAR", symbol: "SR", name: "Saudi Riyal" },
        coordinates: { lat: 24.6871818, lng: 46.68536599999999 },
        address: "طريق الملك فهد الفرعي،، Al Olaya, Riyadh 12211, Saudi Arabia",
    },
    {
        name: "Belgrade Stock Exchange",
        acronym: "BELEX",
        mic: "XBEL",
        country: "Serbia",
        country_code: "RS",
        city: "Belgrade",
        website: "www.belex.rs",
        timezone: {
            timezone: "Europe/Belgrade",
            abbr: "CET",
            abbr_dst: "CEST",
        },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 44.8217307, lng: 20.4126661 },
        address: "Omladinskih brigada 1, Beograd 11070, Serbia",
    },
    {
        name: "Singapore Stock Exchange",
        acronym: "SGX",
        mic: "XSES",
        country: "Singapore",
        country_code: "SG",
        city: "Singapore",
        website: "www.sgx.com",
        timezone: { timezone: "Asia/Singapore", abbr: "+08", abbr_dst: "+08" },
        currency: { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
        coordinates: { lat: 1.27937, lng: 103.849748 },
        address: "Singapore",
    },
    {
        name: "Johannesburg Stock Exchange",
        acronym: "JSE",
        mic: "XJSE",
        country: "South Africa",
        country_code: "ZA",
        city: "Johannesburg",
        website: "www.jse.co.za",
        timezone: {
            timezone: "Africa/Johannesburg",
            abbr: "SAST",
            abbr_dst: "SAST",
        },
        currency: { code: "ZAR", symbol: "R", name: "South African Rand" },
        coordinates: { lat: -26.1033494, lng: 28.057278 },
        address: "2 Gwen Ln, Sandown, Sandton, 2196, South Africa",
    },
    {
        name: "Korean Stock Exchange",
        acronym: "KRX",
        mic: "XKRX",
        country: "South Korea",
        country_code: "KR",
        city: "Seoul",
        website: "http://eng.krx.co.kr",
        timezone: { timezone: "Asia/Seoul", abbr: "KST", abbr_dst: "KST" },
        currency: { code: "KRW", symbol: "₩", name: "South Korean Won" },
        coordinates: { lat: 37.52278889999999, lng: 126.9279862 },
        address:
            "76 Yeouinaru-ro, Yeoeuido-dong, Yeongdeungpo-gu, Seoul, South Korea",
    },
    {
        name: "Bolsas y Mercados Españoles",
        acronym: "BME",
        mic: "BMEX",
        country: "Spain",
        country_code: "ES",
        city: "Madrid",
        website: "www.bolsasymercados.es",
        timezone: { timezone: "Europe/Madrid", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 40.4168861, lng: -3.6921739 },
        address: "Plaza de la Lealtad, 1, 28014 Madrid, Spain",
    },
    {
        name: "Stockholm Stock Exchange",
        acronym: "OMX",
        mic: "XSTO",
        country: "Sweden",
        country_code: "SE",
        city: "Stockholm",
        website: "www.nasdaqomxnordic.com",
        timezone: {
            timezone: "Europe/Stockholm",
            abbr: "CET",
            abbr_dst: "CEST",
        },
        currency: { code: "EUR", symbol: "€", name: "Euro" },
        coordinates: { lat: 59.3398339, lng: 18.1223459 },
        address: "Tullvaktsvägen 15, 105 78 Stockholm, Sweden",
    },
    {
        name: "SIX Swiss Exchange",
        acronym: "SIX",
        mic: "XSWX",
        country: "Switzerland",
        country_code: "CH",
        city: "Zurich",
        website: "www.six-swiss-exchange.com",
        timezone: { timezone: "Europe/Zurich", abbr: "CET", abbr_dst: "CEST" },
        currency: { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
        coordinates: { lat: 47.3916511, lng: 8.5070552 },
        address: "Pfingstweidstrasse 110, 8021 Zürich, Switzerland",
    },
    {
        name: "Taiwan Stock Exchange",
        acronym: "TWSE",
        mic: "XTAI",
        country: "Taiwan",
        country_code: "TW",
        city: "Taipei",
        website: "www.twse.com.tw/en/",
        timezone: { timezone: "Asia/Taipei", abbr: "CST", abbr_dst: "CST" },
        currency: { code: "TWD", symbol: "NT$", name: "New Taiwan Dollar" },
        coordinates: { lat: 25.033718, lng: 121.56481 },
        address:
            "110, Taiwan, Taipei City, Xinyi District, Section 5, Xinyi Rd, 7號9",
    },
    {
        name: "Stock Exchange of Thailand",
        acronym: "SET",
        mic: "XBKK",
        country: "Thailand",
        country_code: "TH",
        city: "Bangkok",
        website: "www.set.or.th",
        timezone: { timezone: "Asia/Bangkok", abbr: "+07", abbr_dst: "+07" },
        currency: { code: "THB", symbol: "฿", name: "Thai Baht" },
        coordinates: { lat: 13.7637191, lng: 100.5676903 },
        address:
            "93 Ratchadaphisek Rd, Khwaeng Din Daeng, Khet Din Daeng, Krung Thep Maha Nakhon 10400, Thailand",
    },
    {
        name: "Istanbul Stock Exchange",
        acronym: "BIST",
        mic: "XIST",
        country: "Turkey",
        country_code: "TR",
        city: "Istanbul",
        website: "www.borsaistanbul.com",
        timezone: { timezone: "Europe/Istanbul", abbr: "+03", abbr_dst: "+03" },
        currency: { code: "TRY", symbol: "TL", name: "Turkish Lira" },
        coordinates: { lat: 41.11053829999999, lng: 29.0392855 },
        address:
            "Reşitpaşa, Borsa İstanbul Cad, 34467 Sarıyer/İstanbul, Turkey",
    },
    {
        name: "Dubai Financial Market",
        acronym: "DFM",
        mic: "XDFM",
        country: "United Arab Emirates",
        country_code: "AE",
        city: "Dubai",
        website: "www.dfm.co.ae",
        timezone: { timezone: "Asia/Dubai", abbr: "+04", abbr_dst: "+04" },
        currency: {
            code: "AED",
            symbol: "AED",
            name: "United Arab Emirates Dirham",
        },
        coordinates: { lat: 25.2272642, lng: 55.28843209999999 },
        address:
            "10 Sheikh Zayed Rd - Trade CentreTrade Centre 2 - Dubai - United Arab Emirates",
    },
    {
        name: "London Stock Exchange",
        acronym: "LSE",
        mic: "XLON",
        country: "United Kingdom",
        country_code: "GB",
        city: "London",
        website: "www.londonstockexchange.com",
        timezone: { timezone: "Europe/London", abbr: "GMT", abbr_dst: "BST" },
        currency: { code: "GBP", symbol: "£", name: "British Pound Sterling" },
        coordinates: { lat: 51.5150534, lng: -0.099034 },
        address: "10 Paternoster Sq., London EC4M 7LS, UK",
    },
    {
        name: "Ho Chi Minh Stock Exchange",
        acronym: "HOSE",
        mic: "XSTC",
        country: "Vietnam",
        country_code: "VN",
        city: "Ho Chi Minh City",
        website: "www.hsx.vn",
        timezone: {
            timezone: "Asia/Ho_Chi_Minh",
            abbr: "+07",
            abbr_dst: "+07",
        },
        currency: { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
        coordinates: { lat: 10.768333, lng: 106.7017906 },
        address:
            "16 Võ Văn Kiệt, Phường Nguyễn Thái Bình, Quận 1, Thành phố Hồ Chí Minh 70000, Vietnam",
    },
    {
        name: "American Stock Exchange",
        acronym: "AMEX",
        mic: "XASE",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.nyse.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.708678, lng: -74.01261459999999 },
        address: "74 Trinity Pl, New York, NY 10006, USA",
    },
    {
        name: "Cboe BZX U.S. Equities Exchang",
        acronym: "BATS",
        mic: "XCBO",
        country: "USA",
        country_code: "US",
        city: "Chicago",
        website: "markets.cboe.com",
        timezone: { timezone: "America/Chicago", abbr: "CDT", abbr_dst: "CDT" },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 41.8767257, lng: -87.6322012 },
        address: "400 S LaSalle St, Chicago, IL 60605, USA",
    },
    {
        name: "US Mutual Funds",
        acronym: "NMFQS",
        mic: "NMFQS",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7701614, lng: -73.98283339999999 },
        address: "13A W 61st St, New York, NY 10023, USA",
    },
    {
        name: "OTC Bulletin Board",
        acronym: "OTCBB",
        mic: "OOTC",
        country: "USA",
        country_code: "US",
        city: "Washington",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 47.7510741, lng: -120.7401385 },
        address: "Washington, USA",
    },
    {
        name: "OTC Grey Market",
        acronym: "OTCGREY",
        mic: "PSGM",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7146797, lng: -74.0172042 },
        address:
            "300 Vesey Street (One North End Ave), 12th Floor, North End Ave, New York, NY 10282, USA",
    },
    {
        name: "OTCQB Marketplace",
        acronym: "OTCQB",
        mic: "OTCB",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7127753, lng: -74.0059728 },
        address: "New York, NY, USA",
    },
    {
        name: "OTCQX Marketplace",
        acronym: "OTCQX",
        mic: "OTCQ",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7146797, lng: -74.0172042 },
        address:
            "300 Vesey Street (One North End Ave), 12th Floor, North End Ave, New York, NY 10282, USA",
    },
    {
        name: "OTC PINK current",
        acronym: "PINK",
        mic: "PINC",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.otcmarkets.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.7146797, lng: -74.0172042 },
        address:
            "300 Vesey Street (One North End Ave), 12th Floor, North End Ave, New York, NY 10282, USA",
    },
    {
        name: "Investors Exchange",
        acronym: "IEX",
        mic: "IEXG",
        country: "USA",
        country_code: "US",
        city: "New York",
        website: "www.iextrading.com",
        timezone: {
            timezone: "America/New_York",
            abbr: "EST",
            abbr_dst: "EDT",
        },
        currency: { code: "USD", symbol: "$", name: "US Dollar" },
        coordinates: { lat: 40.706877, lng: -74.0112654 },
        address: "11 Wall St, New York, NY 10005, USA",
    },
];
